import * as React from "react";

const SoaringLogoLoader = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="569"
    height="123"
    fill="#fff"
    version="1.2"
    viewBox="0 0 569 123"
  >
    <path
      d="M16.2 93.6 30 77c8.9 7.1 18.8 10.8 29.1 10.8 6.7 0 10.3-2.3 10.3-6.2v-.2c0-3.8-2.9-5.8-15.1-8.6-19.1-4.4-33.9-9.8-33.9-28.2v-.3c0-16.7 13.2-28.7 34.8-28.7 15.2 0 27.2 4.1 36.9 11.9L79.7 45.1c-8.3-5.8-17.2-8.9-25.2-8.9-6 0-9 2.6-9 5.8v.2c0 4.1 3.1 5.9 15.6 8.8 20.6 4.4 33.4 11.1 33.4 27.9v.3c0 18.3-14.5 29.2-36.3 29.2-15.9 0-31-5-42-14.8M100.3 68.5v-.2c0-22.1 17.8-40.1 41.6-40.1s41.5 17.8 41.5 39.9v.2c0 22.2-17.9 40.1-41.7 40.1s-41.4-17.7-41.4-39.9m61.2 0v-.2c0-11.1-8-20.8-19.8-20.8s-19.5 9.5-19.5 20.6v.2c0 11.2 8 20.9 19.7 20.9s19.6-9.5 19.6-20.7M214 29.2h20.6l32.9 77.7h-23l-5.6-13.8h-29.7l-5.5 13.8h-22.5zm18.7 47.3-8.6-21.9-8.7 21.9zM272.7 29.8h36.5c11.8 0 20 3.1 25.1 8.3q6.9 6.6 6.9 18v.2c0 11.8-6.3 19.6-15.9 23.7l18.4 26.9H319l-15.5-23.4h-9.4v23.4h-21.4zm35.5 37c7.3 0 11.5-3.5 11.5-9.2v-.2c0-6-4.4-9.1-11.6-9.1h-14v18.5zM350.2 29.8h21.5v77.1h-21.5zM383.6 29.8h20l31.7 40.7V29.8h21.2v77.1h-18.8l-32.9-42.3v42.3h-21.2zM466 62.3V62c0-26.2 20.5-46.7 48.3-46.7 15.8 0 27 4.9 36.5 13.1L536.1 46c-6.4-5.4-12.8-8.5-21.6-8.5-13 0-23 10.9-23 24.6v.3c0 14.5 10.1 24.9 24.4 24.9 6 0 10.6-1.3 14.3-3.8V72.6h-17.7V54.4h41.3v40.4c-9.5 7.9-22.7 13.9-39 13.9-27.9 0-48.8-19.3-48.8-46.4"
      className="s0"
    ></path>
  </svg>
);

export default SoaringLogoLoader;
